import * as React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import { StaticImage } from 'gatsby-plugin-image';
import { getStoryblokAlt } from '../../helpers/common';

export default function HorizontalImageList({ blok }) {
  const items = [];
  for (let i = 1; i <= 2; i++) {
    if (blok?.[`image_${i}`]) {
      items.push({
        image: blok[`image_${i}`],
        heading: blok[`heading_${i}`],
        subheading: blok[`subheading_${i}`],
      });
    }
  }

  return (
    <div {...storyblokEditable(blok)}>
      {items.length > 0
                && (
                <div className="flex flex-wrap justify-center text-center mb-10 gap-12">
                  {items.map((item, index) => (
                    <div key={index} className="flex flex-col items-center">
                      <div>
                        <picture>
                          <source
                            type="image/avif"
                            srcSet={item.image?.filename ? `${item.image.filename}/m/208x208/filters:format(avif) 1x, ${item.image.filename}/m/416x416/filters:format(avif) 2x` : undefined}
                          />
                          <img
                            alt={getStoryblokAlt(item.image)}
                            className="h-52 w-52 rounded-full mb-4"
                            src={item.image?.filename ? `${item.image.filename}/m/416x416/filters:format(webp)` : undefined}
                            width={208}
                            height={208}
                            loading="lazy"
                          />
                        </picture>
                      </div>
                      {item.heading}
                      {item.subheading && (
                      <>
                        <br />
                        {item.subheading}
                      </>
                      )}
                    </div>
                  ))}
                </div>
                )}
    </div>
  );
}
